import React from 'react';
import { Alert } from 'antd';
import GenericFormFill from './GenericFormFill';

type PreviewPayload = {
  svg: string;
  fields: any[];
  pdfWidth?: number;
  pdfHeight?: number;
};

const STORAGE_KEY = 'form_preview_payload_v1';

const FormPreview: React.FC = () => {
  const [payload, setPayload] = React.useState<PreviewPayload | null>(null);
  const [fieldValues, setFieldValues] = React.useState<Record<string, any>>({});

  React.useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY) ?? sessionStorage.getItem(STORAGE_KEY);
      if (!raw) {
        setPayload(null);
        return;
      }
      const parsed = JSON.parse(raw) as PreviewPayload;
      if (!parsed?.svg || !Array.isArray(parsed.fields)) {
        setPayload(null);
        return;
      }
      setPayload(parsed);
    } catch {
      setPayload(null);
    }
  }, []);

  if (!payload) {
    return (
      <div style={{ padding: 24 }}>
        <Alert
          type="warning"
          showIcon
          message="No preview data found"
          description="Go back to the form generator and click Preview again."
        />
      </div>
    );
  }

  return (
    <div style={{ padding: 24 }}>
      <GenericFormFill
        svg={payload.svg}
        fields={payload.fields}
        formSpecificFields={{}}
        formDefinition={{ pdfWidth: payload.pdfWidth, pdfHeight: payload.pdfHeight }}
        fieldValues={fieldValues}
        setFieldValues={setFieldValues}
      />
    </div>
  );
};

export default FormPreview;
